module.exports = __webpack_public_path__ + "img/zjy.a80311f3.jpg";